import Transform from "@ember-data/serializer/transform";
import type BioExamResult from "parog-web/models/bio-exam-result";

export default class BioExamResultsTransform extends Transform {
  override deserialize(serialized) {
    return serialized;
  }

  override serialize(bioExamResults: BioExamResult[] | undefined) {
    if (!bioExamResults) return;
    return bioExamResults.map(bioExamResult => {
      return {
        id: bioExamResult.id,
        label: bioExamResult.label,
        code: bioExamResult.code,
        value: bioExamResult.value,
        unit: bioExamResult.unit,
        "norm-val-inf": bioExamResult.normValInf,
        "norm-val-supp": bioExamResult.normValSupp,
        "original-line": bioExamResult.originalLine,
        "oru-status": bioExamResult.oruStatus,
        "is-draft": bioExamResult.isDraft,
        "match-type": bioExamResult.matchType,
        operator: bioExamResult.operator,
        "selected-raw-unit": bioExamResult.selectedRawUnit,
        uuid: bioExamResult.uuid,
        "occurred-on": bioExamResult.occurredOn,
        "qualitative-value-translation":
          bioExamResult.qualitativeValueTranslation,
        _destroy: bioExamResult._destroy
      };
    });
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "bio-exam-results": BioExamResultsTransform;
  }
}
